exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "tooltip-mobile .icon-interrogation-color{font-size:16px;cursor:pointer}tooltip-mobile .modal .modal-dialog .modal-content{background:#0072c9;padding:30px}tooltip-mobile .modal .modal-dialog .modal-content .icon-cross{position:absolute;top:30px;right:30px;color:#fff;font-size:22px;cursor:pointer;z-index:1}tooltip-mobile .modal .modal-dialog .modal-content .modal-body{padding-top:30px}tooltip-mobile .modal .modal-dialog .modal-content p{font-size:13px;color:#fff;font-family:Stag Sans;text-align:left;text-transform:none}tooltip-mobile .modal .modal-dialog .modal-content p.tooltip-title{font-size:16px;text-align:left;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/tooltipMobile/tooltipMobile.scss
// module id = 1026
// module chunks = 0